// Thin GA4 wrapper. Loads gtag.js only when REACT_APP_GA_MEASUREMENT_ID is set.
// Without an ID every call is a no-op (events are echoed to the console in development).
const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const DEV = process.env.NODE_ENV !== "production";

export const analyticsEnabled = Boolean(GA_ID);

let loaded = false;

export function initAnalytics() {
  if (!GA_ID || loaded || typeof window === "undefined") return;
  loaded = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  // SPA: we send page_view manually on route change.
  window.gtag("config", GA_ID, { send_page_view: false, anonymize_ip: true });
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
}

export function trackEvent(name, params = {}) {
  if (DEV) console.debug("[analytics]", name, params);
  if (!GA_ID || typeof window.gtag !== "function") return;
  window.gtag("event", name, params);
}

export function trackPageView(path, title) {
  trackEvent("page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: title || document.title,
  });
}

// Event vocabulary used across the site (keep in sync with the analytics report).
export const EVENTS = {
  ctaPrimary: "cta_primary_click", // "Discuss an Initiative"
  ctaSecondary: "cta_secondary_click", // any other CTA button
  contactSubmit: "contact_form_submit", // successful POST /api/contact
  scheduling: "scheduling_click", // Calendly link / embed opened
  scrollDepth: "scroll_depth", // 25 / 50 / 75 / 90 %
};
